import { useEffect, useMemo, useState } from "react";
import { routes } from "../../../app/routes";
import { UrlService } from "../../../services";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const AppointmentsIndexTopbar = (props: any) => {
  const returnUrl = UrlService.getQueryParams("returnUrl");

  const defaultSubmenuItems: TopbarMenuItem[] = useMemo((): TopbarMenuItem[] => [
    {
      label: "Appointments",
      icon: IconDefinitions.clipboard,
      url: routes.appointments.index,
      activeMatch: routes.appointments.index,
      activeMatchExact: true,
    },
  ], []);

  useEffect(() => {
    const backItem: TopbarMenuItem = {
      label: "Back",
      icon: IconDefinitions.back,
      url: returnUrl ?? "",
    };

    if (returnUrl) {
      setSubmenuItems([backItem, ...defaultSubmenuItems]);
    } else {
      setSubmenuItems(defaultSubmenuItems);
    }
  }, [defaultSubmenuItems, returnUrl]);

  const [submenuItems, setSubmenuItems] =
    useState<TopbarMenuItem[]>(defaultSubmenuItems);

  return <TopbarSubmenu className="p-0" items={submenuItems}></TopbarSubmenu>;
};

export default AppointmentsIndexTopbar;
